import { Plus, X } from "lucide-react";

import type { GroupedSkill } from "../../../components/ResumeBuilder/SkillsEditorListItems/SkillsEditorListItems";
import CustomInputSkill from "./CustomInputSkill";
import SingleSkillItem from "./SingleSkillItem";

interface GroupedSkillsItemProps {
	item: GroupedSkill;
	collapseGroupedSkills: (groupedSkillIndex: number) => void;
	groupedSkillIndex: number;
	removeGroupedSkills: (skillTitle: string) => void;
	onSaveCustomSkillAdded: (groupedSkillIndex: number, singleSkillIndex: number, skillAdded: string) => void;
	onSelectSingleSkill: (groupedSkillIndex: number, singleSkillIndex: number) => void;
	onAddCustomSkill: (groupedSkillIndex: number) => void;
}

function GroupedSkillsItem({
	item,
	collapseGroupedSkills,
	groupedSkillIndex,
	removeGroupedSkills,
	onSaveCustomSkillAdded,
	onSelectSingleSkill,
	onAddCustomSkill,
}: GroupedSkillsItemProps) {
	return (
		<div
			className="mb-3 box-border flex max-w-[508px] flex-col items-start justify-end self-stretch rounded-md border border-[#d5dbe1] px-4 py-2"
			style={{ ...(item.collapsed && { backgroundColor: "#EFF9FF", cursor: "pointer" }) }}
			onClick={() => item.collapsed && collapseGroupedSkills(groupedSkillIndex)}
		>
			<div className="flex w-full max-w-[476px] flex-col items-start justify-center gap-3 self-stretch pt-2 pb-3">
				<div className="flex w-full flex-row items-center gap-3 self-stretch">
					<div className="mr-auto font-semibold text-black text-sm leading-5">{item.title}</div>
					<button
						type="button"
						className="cursor-pointer"
						aria-label={item.collapsed ? "Expand" : "Remove"}
						onClick={() =>
							item.collapsed ? collapseGroupedSkills(groupedSkillIndex) : removeGroupedSkills(item.title)
						}
					>
						{item.collapsed ? <Plus className="size-4" /> : <X className="size-4" />}
					</button>
				</div>
				{!item.collapsed && (
					<>
						<div className="flex w-full max-w-[476px] flex-row flex-wrap content-start items-center gap-3 self-stretch">
							{item.skills.map((singleSkill, singleSkillIndex) => {
								if (singleSkill.skill === "") {
									return (
										<CustomInputSkill
											key={singleSkillIndex}
											groupedSkillIndex={groupedSkillIndex}
											singleSkillIndex={singleSkillIndex}
											onSaveCustomSkillAdded={onSaveCustomSkillAdded}
										/>
									);
								}
								return (
									<SingleSkillItem
										key={singleSkill.skill}
										onSelectSingleSkill={onSelectSingleSkill}
										singleSkill={singleSkill}
										groupedSkillIndex={groupedSkillIndex}
										singleSkillIndex={singleSkillIndex}
									/>
								);
							})}
						</div>
						<div
							className="flex cursor-pointer items-center"
							onClick={() => {
								onAddCustomSkill(groupedSkillIndex);
							}}
						>
							<Plus className="mr-2 size-4 text-[#019ce0]" />
							<span className="font-semibold text-[#019ce0] text-sm leading-5">Add custom</span>
						</div>
					</>
				)}
			</div>
		</div>
	);
}

export default GroupedSkillsItem;
